export default "__VITE_ASSET__Dl9n$vmv__"